import { Option } from '@common/types/common';
import { api } from '@services/api';

const accessRecoveryApi = api.injectEndpoints({
    endpoints: (builder) => ({
        createPinPukRecoveryRequest: builder.mutation<void, FormData>({
            query: (formData) => ({
                url: '/access-recovery/pin-puk/',
                method: 'POST',
                body: formData,
            }),
        }),
        createVrmRecoveryRequest: builder.mutation<void, FormData>({
            query: (formData) => ({
                url: '/access-recovery/vrm/',
                method: 'POST',
                body: formData,
            }),
        }),
        getVrmRequestTypes: builder.query<Option<string>[], void>({
            query: () => '/access-recovery/vrm/request-types/',
            providesTags: ['VRMRequestTypes'],
        }),
        validateSerialNumber: builder.query<
            {
                is_valid_serial_number: boolean;
                is_gx_device: boolean;
            },
            { serialNumber: string }
        >({
            query: ({ serialNumber }) => `/access-recovery/serial-number/${serialNumber}/validate/`,
            providesTags: (_result, _error, { serialNumber }) => [{ type: 'ValidateSerialNumber', id: serialNumber }],
        }),
    }),
});

export const {
    useCreatePinPukRecoveryRequestMutation,
    useCreateVrmRecoveryRequestMutation,
    useGetVrmRequestTypesQuery,
    useValidateSerialNumberQuery,
} = accessRecoveryApi;

export const selectValidateSerialNumber = accessRecoveryApi.endpoints.validateSerialNumber.select;
